import { UnAuthAPIName } from 'src/constants';
import { PaymentInfo } from 'src/store/payments/types';
import { API } from 'src/utils/AmplifyApiUtils';

import { appAPI } from '.';

export const paymentInfoApi = appAPI.injectEndpoints({
  endpoints: (build) => ({
    getPaymentInfo: build.query<PaymentInfo, { skip: boolean }>({
      queryFn: async ({ skip }) => {
        if (skip) {
          return { data: null };
        }
        const data = await API.get(UnAuthAPIName, `/public/paymentinfo`, {});
        return { data };
      },
    }),
  }),
});

export const { useGetPaymentInfoQuery } = paymentInfoApi;
